import { ACTION_PLAN_FORM_ID, FOOD_JOURNAL_FORM_ID, RECOMMENDATION_FORM_ID } from "common/constants";
import { Formik } from "formik";
import { otpValidation } from "helpers/validationHelper";
import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { object } from "yup";
import OtpInput from 'react-otp-input';
import OTPTimer from "components/shared/OTPTimer";
import { getPhoneValue } from "helpers/common";

const validation = object({
  otp: otpValidation
});

const VerifyPhoneOtpPopup = ({ showPopup, handleClose, handleVerify, handleResendOtp, phone }) => {
  
  const onClose = () => {
    handleClose()
  }

  return (
    <>
      <Formik
        initialValues={{ otp: "" }}
        enableReinitialize
        validationSchema={validation}
        onSubmit={handleVerify}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          submitForm,
          isSubmitting,
        }) => (
          <div className="FormBody">
            <Form onSubmit={handleSubmit}>
              <Modal
                show={showPopup}
                onHide={onClose}
                backdrop="static"
                keyboard={false}
                centered
                className="FormPop"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Verify Phone Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row className="justify-content-start">
                    <Col lg="12" className="">
                      {/* {console.log("values", values, validation.validate(values).then(result => console.log("result", result)))} */}
                      <Row>
                        <Col lg="12" className="py-2 text-center">
                          {/* <label
                          htmlFor=""
                          className="form-label m-0 py-1 fw-sbold d-block text-center"
                        >
                          Enter OTP
                        </label> */}
                          <div className="my-2">
                            <p className="m-0">
                              {phone && `OTP is sent to your phone ${getPhoneValue(phone)}`}
                            </p>
                          </div>
                          <div className="OtpCstm d-flex align-items-center gap-10 justify-content-center text-center">
                            <OtpInput
                              containerStyle="otp-container"
                              inputStyle="otp-input-field"
                              value={values.otp}
                              onChange={(value) => {
                                setFieldValue("otp", value);
                              }}
                              numInputs={4}
                              renderSeparator={<span className="otp-seperator">-</span>}
                              renderInput={(props) => <input {...props} />}
                            />
                          </div>
                          {(errors.otp && touched.otp) &&
                            <p className="invalid-feedback d-block m-0 py-2">{errors.otp}</p>
                          }
                          <div className="py-2">
                            <OTPTimer
                              onResend={async (callback) => {
                                await handleResendOtp(callback);
                                setFieldValue("otp", "");
                              }}
                            />
                          </div>
                        </Col>
                        {/* <Col lg="12" className="my-2">
                          <div className="d-flex justify-content-end gap-10">
                            
                          </div>
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn btnSm"
                    onClick={onClose}
                  >
                    Close
                  </Button>
                  <Button
                    type="submit"
                    className="d-flex align-items-center justify-content-center commonBtn btnSm"
                    onClick={submitForm}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Please wait..." : "Verify OTP"}
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>

          </div>
        )}
      </Formik>
    </>
  );
};

export default VerifyPhoneOtpPopup;
